import React, { useRef, useState } from "react";
import { TieredMenu } from "primereact/tieredmenu";
import { CheveronDown } from "../../constant";
import DotBall from "../DotBall";
import classes from "./ActiveAndInActiveControl.module.css";
const derivedStatus = (status) => {
  if (status === "Active") {
    return <DotBall bookingStatus={1} />;
  } else if (status === "Maintenance") {
    return <DotBall bookingStatus={2} />;
  }
  // If status is pending (3) but the booking date has passed, show as cancelled
};
const ActiveAndInActiveControl = ({ value, setter, menuItems}) => {
  const menu = useRef(null);

  return (
    <>
      <style jsx>
        {`
          .p-tieredmenu.p-tieredmenu-overlay {
            z-index: 99999999 !important;
          }
        `}
      </style>

      <span className={classes.title}>
        {derivedStatus(value)}
        {/* Only show dropdown for genuine pending bookings that haven't passed */}
        <span>{value}</span>
        <span
          className={classes.status}
          onClick={(e) => menu.current.toggle(e)}
        >
          <CheveronDown className={classes.icon} />
        </span>

        <TieredMenu
          popup
          ref={menu}
          model={menuItems?.filter((item) => item.label != value)}
          breakpoint="767px"
        />
      </span>
    </>
  );
};

export default ActiveAndInActiveControl;
